<template>
  <div class="productQuotationApplicationAdd container">
    <div class="searchBox">
      <div style="margin-bottom: 10px">
        <!-- <el-button v-if="saveSubmitBtnShow" type="primary" @click="updateQuotation('save')">保存</el-button>
        <el-button v-if="saveSubmitBtnShow" type="primary" @click="updateQuotation('submit')">提交</el-button> -->
        <!--预估年总费用保存-->
        <el-button size="mini" class="btn" v-acl="ProductQuoteMcdSave" v-if="estimatedAnnualFeeBtnShow" type="primary" @click="updateQuotation('save')">{{$t('apply.annualTotalCostSave')}}</el-button>
        <el-button size="mini" class="btn" type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
        <!--关闭-->
      </div>
      <el-form label-width="120px" ref="applyInfoForm" :model="headData" label-position="right" class="topform">
        <el-row :gutter="20">
          <el-col :xs="1" :md="12" :lg="8" :xl="6">
            <el-form-item label="单据编号">
              <el-input class="handle-input" v-model="headData.applyNo" disabled style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="1" :md="12" :lg="8" :xl="6">
            <el-form-item label="主题">
              <el-input class="handle-input" v-model="headData.subject" disabled style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="1" :md="12" :lg="8" :xl="6">
            <el-form-item label="创建人">
              <el-input class="handle-input" v-model="headData.name" disabled style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="1" :md="12" :lg="8" :xl="6">
            <el-form-item label="创建日期">
              <el-date-picker value-format="yyyy-MM-dd" type="date" v-model="headData.createDate" placeholder="选择日期" disabled style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="产品报价明细" name="first">
        <el-row type="flex" justify="start" align="middle" style="margin-bottom: 10px">
          <el-upload v-if="$route.query.roundStatus=='2'&&!isShowBtn" :on-error="importDetailError" :on-success="importDetailSuccess" :before-upload="beforeUpload" :action="importDetailUrl" multiple="false" :headers="headers" :show-file-list="false" class="apply-import-button">
            <el-button size="mini" type="primary">{{$t('common.import')}}</el-button>
          </el-upload>
          <el-button size="mini" v-if="!isShowBtn" class="btn" type="primary" @click="exportDetails">{{$t('common.export')}}</el-button>
          <p style="color:red" v-if="!isShowBtn">(仅导出非标准线路运费为否的行项目，导入可更新预估年总费用)</p>
        </el-row>
        <ux-grid ref="applyProductTableDataRef" :data="applyProductTableData" keep-source @sort-change="changeSort" :row-class-name="tableRowClassName" highlight-current-row max-height="550" show-overflow="tooltip">
          <!-- <ux-table-column align="center" type="checkbox" width="80" /> -->
          <ux-table-column align="center" title="操作" min-width="80" v-if="!estimatedAnnualFeeEditFlag">
            <template v-slot="scope">
              <i :class="scope.row.colour=='Y'?'el-icon-edit-outline fff':'el-icon-edit-outline'" @click="onEdit(scope)"></i>
            </template>
          </ux-table-column>
          <ux-table-column align="center" title="序号" type="index" width="60"></ux-table-column>
          <ux-table-column align="center" v-for="(item,index) in columns" :key="index" resizable :field="item.prop" :title="item.label" sortable :min-width="item.width"></ux-table-column>
          <ux-table-column align="center" resizable field="isSpecialFreight" title="非标准线路运费" sortable min-width="150">
            <template v-slot="scope">
              {{scope.row.isSpecialFreight |setIsSpecialFreight}}
            </template>
          </ux-table-column>
          <ux-table-column align="center" v-for="(item,index) in columns1" :key="index" resizable :field="item.prop" :title="item.label" sortable :min-width="item.width"></ux-table-column>
        </ux-grid>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="报价明细" :visible.sync="dialogEditVisible" width="80%" @close="onCancel">
      <el-form ref="formTable" :model="formTable" inline>
        <el-table :data="formTable.tableData" ref="tableDataRef" border highlight-current-row max-height="470">
          <el-table-column show-overflow-tooltip sortable="custom" prop="supplierName" label="供应商" min-width="160px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="eightBitCode" label="8位码" min-width="120px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="eightBitCodeName" label="8位码名称" min-width="120px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="pickupPoint" label="发货市" min-width="120px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="dcName" label="到货仓库" min-width="120px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="temperatureI18n" label="温区" min-width="120px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="effectiveBeginDate" label="有效开始日期" min-width="120px">
            <template slot-scope="scope">
              {{scope.row.effectiveBeginDate | dateFormatFilter("YYYY-MM-DD")}}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="isSpecialFreight" label="非标准线路运费" :formatter="formatisSpecial" min-width="150px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="transportaionMethod" label="运输方式" min-width="120px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="lineUnit" label="结算单位" min-width="120px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="linePrice" label="线路价格" min-width="120px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="productPrice" label="产品运费（不含税）" min-width="180px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="estimatedAnnualFee" :label="$t('apply.estimatedAnnualTotalCost')" width="160px">
            <template slot-scope="scope">
              <el-form-item :prop=" 'tableData.' + scope.$index + '.estimatedAnnualFee' " :rules="rules.estimatedAnnualFee">
                <el-input v-model="scope.row.estimatedAnnualFee"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="changeRate" label="价格变化" min-width="120px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="currencyCode" label="币种" min-width="100px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="leadTime" label="LeadTime" min-width="120px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="externalPackagingLength" label="外包装长(cm)" min-width="120px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="externalPackagingWidth" label="外包装宽(cm)" min-width="120px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="externalPackagingHeight" label="外包装高(cm)" min-width="120px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="externalPackagingNetweight" label="外包装净重(kg)" min-width="130px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="externalPackagingGrossweight" label="外包装毛重(kg)" min-width="130px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="palletLayerNumber" label="每Pallet层数" min-width="120px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="palletLayerBoxNumber" label="每层箱数" min-width="120px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="palletItemsLength" label="托盘上物品长度(cm)" min-width="170px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="palletItemsWidth" label="托盘上物品宽度(cm)" min-width="170px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="palletItemsHeight" label="托盘上物品高度(cm)" min-width="170px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="remarks" label="备注" min-width="120px"></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" prop="sourcingProductStatus" label="报价确认审批状态" min-width="170px"></el-table-column>
        </el-table>
        <el-row type="flex" justify="center" style="margin-top:10px;">
          <el-button type="primary" @click="onConfirm">确认</el-button>
          <el-button type="primary" @click="onCancel">取消</el-button>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { Loading } from "element-ui";
import { Message } from "element-ui";
import {
  getApplyDetail,
  predictYearCost,
  exportDetail
} from "@/api/quoteByProduct.js";
import { fileService } from "@/api/common/file-utils";
import commonFun from "@/utils/commonFun";
import commonConstants from "@/constants/commonConstants";

export default {
  name: "inquiryQuotationProductDetail",
  data() {
    let checkPrice = (rule, value, callback) => {
      let _this = this;
      let fieldVal = rule.field;
      let fieldName = fieldVal.substr(fieldVal.lastIndexOf(".") + 1);
      let reg = new RegExp(/.(\d)+./)
      let indexVal = commonFun.trim(reg.exec(fieldVal)[0], ".") * 1;
      let row = this.formTable.tableData[indexVal];
      if ((row.isSpecialFreight == 'N' && commonFun.isEmpty(row.tmLineId)) && (value == null || (value + "").trim() == "")) {
        callback(new Error("金额不能为空"))
      } else if (commonFun.isEmpty(value)) {
        callback();
        return;
      } else {
        let trimVal = (value + "").trim();
        let number = trimVal * 1;
        if (isNaN(number)) {
          callback(new Error("请正确输入金额!"))
        } else {
          let decimalLength = 0;
          trimVal = number + '';
          let pointIndex = trimVal.indexOf('.');
          if (pointIndex != -1) {
            decimalLength = trimVal.substr(pointIndex + 1).length;
          }
          let reg = /^(0|[1-9]\d{0,14})(\.\d{1,6})?$/;//d{1,6}
          if (!reg.test(trimVal)) {
            if (trimVal.indexOf('-') != -1) {
              //自动去 除负号
              let intVal = trimVal.substr(1);
              //如果超过六位进行四舍五入操作
              if (decimalLength > 6) {
                this.formTable.tableData[indexVal][fieldName] = Math.round(trimVal * 1000000) / 1000000;
              } else {
                this.formTable.tableData[indexVal][fieldName] = intVal;
              }
            } else {
              //如果超过六位进行四舍五入操作
              if (decimalLength > 6) {
                this.formTable.tableData[indexVal][fieldName] = Math.round(trimVal * 1000000) / 1000000;
              }
            }
          } else {
            this.formTable.tableData[indexVal][fieldName] = trimVal;
            callback()
          }
        }
      }
    }
    return {
      loadingInstance: null,
      columns: [
        { prop: "supplierName", label: "供应商", width: "160" },
        { prop: "eightBitCode", label: "8位码", width: "120" },
        { prop: "eightBitCodeName", label: "8位码名称", width: "120" },
        { prop: "pickupPoint", label: "发货市", width: "120" },
        { prop: "dcName", label: "到货仓库", width: "120" },
        { prop: "temperatureI18n", label: "温区", width: "90" },
        { prop: "effectiveBeginDate", label: "有效开始日期", width: "150" },
        // { prop: "isSpecialFreight", label: "非标准线路运费", width: "150" },
      ],
      columns1: [
        { prop: "transportaionMethod", label: "运输方式", width: "120" },
        { prop: "lineUnit", label: "结算单位", width: "120" },
        { prop: "linePrice", label: "线路价格", width: "120" },
        { prop: "productPrice", label: "产品运费（不含税）", width: "180" },
        { prop: "estimatedAnnualFee", label: '预估年总费用', width: "160" },
        { prop: "changeRate", label: "价格变化", width: "120" },
        { prop: "currencyCode", label: "币种", width: "100" },
        { prop: "leadTime", label: "LeadTime", width: "140" },
        { prop: "externalPackagingLength", label: "外包装长(cm)", width: "140" },
        { prop: "externalPackagingWidth", label: "外包装宽(cm)", width: "140" },
        { prop: "externalPackagingHeight", label: "外包装高(cm)", width: "140" },
        { prop: "externalPackagingNetweight", label: "外包装净重(kg)", width: "140" },
        { prop: "externalPackagingGrossweight", label: "外包装毛重(kg)", width: "140" },
        { prop: "palletLayerNumber", label: "每Pallet层数", width: "140" },
        { prop: "palletLayerBoxNumber", label: "每层箱数", width: "140" },
        { prop: "palletItemsLength", label: "托盘上物品长度(cm)", width: "180" },
        { prop: "palletItemsWidth", label: "托盘上物品宽度(cm)", width: "180" },
        { prop: "palletItemsHeight", label: "托盘上物品高度(cm)", width: "180" },
        { prop: "remarks", label: "备注", width: "120" },
        { prop: "sourcingProductStatus", label: "报价确认审批状态", width: "170" },
      ],
      isShowBtn: false,
      applyProductTableData: [],
      activeName: 'first',
      ttQuotationApplyId: null,
      submitBtnShow: false,
      saveBtnShow: false,
      showUploadFlag: false,
      headData: {},
      materialSearchForm: {
        eightBitCode: "",
        eightBitCodeName: "",
        plantName: "",
        supplierCode: "",
        supplierName: "",
        pickupPoint: "",
        dcName: "",
        temperature: "",
        transportaionMethod: ""
      },
      rules: {
        estimatedAnnualFee: [
          { type: 'number', validator: checkPrice, message: "", trigger: ['blur'] }
        ]
      },
      transportaionMethodList: [],

      fileList: [],
      materialList: [],
      SelectionChangeMateriaObj: [],
      saveSubmitBtnShow: false,
      comeForm: '',//用于记录来源,主要用于结束询价的预估年总费用维护
      estimatedAnnualFeeEditFlag: true,//控制预估年总费用是否可编辑
      estimatedAnnualFeeBtnShow: false,//控制预估年总旨用保存按钮显示
      page: {
        size: 10,
        current: 1,
        total: 0
      },
      ttQuotationId: "",
      dialogEditVisible: false,
      index: null,
      formTable: {
        tableData: []
      },
    };
  },
  created() {
    this.comeForm = this.$route.query.from;
    this.ttQuotationApplyId = this.$route.query.applyId;
    this.quotationPageInitM(this.$route.query.applyId);
  },
  filters: {
    setIsSpecialFreight(key) {
      if (key == 'Y') {
        return '是'
      } else if (key == 'N') {
        return '否'
      } else {
        return key
      }
    },
  },
  computed: {
    importDetailUrl() {
      return commonConstants.baseUrl + `productQuote/importDetail/${this.ttQuotationId}`;
    },
    headers() {
      return {
        "x-access-token": localStorage.getItem('token')
      }
    }
  },
  methods: {
    quotationPageInitM(applyId) {
      let _this = this;
      getApplyDetail(applyId).then(res => {
        this.headData = res.quotationApply;
        if (res.quotationProductList) {
          _this.applyProductTableData = res.quotationProductList;
          _this.isShowBtn = res.quotationProductList.every(ele => {
            return ele.isSpecialFreight == 'Y'
          })
          console.log('isShowBtn', _this.isShowBtn);
        }
        _this.ttQuotationId = res.ttQuotationId;
        _this.supplierList = res.supplierList;
        if (!!res.supplierList) {
          _this.fileList = [];
          res.supplierList.forEach((sup, index) => {
            _this.fileList.push([]);
            _this.getFiles(sup.tmSupplierId, index);
          })
        }
        if ((_this.comeForm == 'eq' || res.ownerFlag == true) && res.status == '2') {
          //来自于结束询价时预算年总费用维护，控制只能编辑单一字段
          _this.estimatedAnnualFeeBtnShow = true;
          _this.estimatedAnnualFeeEditFlag = false;
        }
        this.$refs.applyProductTableDataRef.reloadData(res.quotationProductList)
      });
    },
    onEdit(scope) {
      console.log('scope', scope);
      this.dialogEditVisible = true
      this.index = scope.rowIndex
      this.formTable.tableData.push(JSON.parse(JSON.stringify(scope.row)))
      console.log('this.formTable.tableData', this.formTable.tableData);
    },
    onConfirm() {
      this.$refs.applyProductTableDataRef.reloadRow(this.$refs.applyProductTableDataRef.data[this.index], this.$refs.tableDataRef.data[0], null)
      this.dialogEditVisible = false
      setTimeout(() => {
        this.formTable.tableData = []
      }, 500);
    },
    onCancel() {
      this.dialogEditVisible = false
      this.formTable.tableData = []
      this.$refs.applyProductTableDataRef.revertData(this.$refs.applyProductTableDataRef.data[this.index])
    },
    beforeUpload(file) {
      this.loadingInstance = Loading.service({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    importDetailSuccess(resp) {
      if (resp.meta.code === 200) {
        this.$message.success('导入完成,已导入数据' + resp.data + '条')
        this.quotationPageInitM(this.ttQuotationApplyId);
      } else {
        this.$message.error(resp.meta.msg)
      }
      this.loadingInstance.close();
    },
    importDetailError(resp) {
      this.loadingInstance.close();
      Message.error(JSON.parse(resp.message).msg);
    },
    exportDetails() {
      exportDetail(this.ttQuotationId).then(res => {
        fileService.respToFile(res, 'RFQ(Material)-预估年总费用&' + this.headData.applyNo + '.xlsx');
      })
    },
    updateQuotation: function (method) {
      let _this = this
      // let validFlag = false;
      // this.$refs['formTable'].validate((valid) => {
      //   validFlag = valid;
      // });
      // if (!validFlag) {
      //   return;
      // }
      for (var i = 0; i < _this.applyProductTableData.length; i++) {
        let item = _this.applyProductTableData[i];
        if (item.isSpecialFreight === 'N' && commonFun.isEmpty(item.tmLineId)) {
          if (commonFun.isEmpty(item.estimatedAnnualFee)) {
            _this.$message({ message: '第' + (i + 1) + '行' + "预估年总费用不能为空", type: "warning" });
            return;
          }
          if (commonFun.isNotEmpty(item.estimatedAnnualFee)) {
            if (isNaN(item.estimatedAnnualFee * 1)) {
              _this.$message({ message: '第' + (i + 1) + '行' + "请正确输入预估年总费用!", type: "warning" });
              return;
            }
          }
        }
      }
      predictYearCost(_this.applyProductTableData).then((res) => {
        Message({ message: '预估年总费用保存成功', type: "success" });
      });
    },
    historyBack: function () {
      this.$router.go(-1);
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then((res) => { })
    },
    //文件列表数据获取
    getFiles: function () {
      let attachment = {};
      attachment.seq = '1';
      attachment.tsRecId = this.ttQuotationApplyId;
      attachment.tsReckindId = 'QUOTATION_APPLY';
      fileService.getFileList(attachment).then((fileRes) => {
        this.fileList = fileRes;
      })
    },
    changeSort: function (column) {
      // //清除校验
      // let $ref = this.$refs['formTable'];
      // this.$nextTick(() => {
      //   $ref.clearValidate();
      // })
      //获取字段名称和排序类型
      let fieldName = column.prop;
      let sortingType = column.order;
      //如果字段名称为“effectiveBeginDate”，将“创建时间”转换为时间戳，才能进行大小比较
      if (fieldName == "effectiveBeginDate") {
        this.applyProductTableData.map(item => {
          item.effectiveBeginDate = new Date(item.effectiveBeginDate).getTime()
        });
      }
      if (fieldName == "externalPackagingHeight" || fieldName == "externalPackagingNetweight" || fieldName == "externalPackagingGrossweight" || fieldName == "palletLayerNumber" || fieldName == "palletLayerBoxNumber" || fieldName == "effectiveBeginDate" || fieldName == "eightBitCode" || fieldName == "linePrice" || fieldName == "leadTime" || fieldName == "estimatedAnnualFee" || fieldName == "productPrice" || fieldName == "externalPackagingLength" || fieldName == "externalPackagingWidth") {
        //数字按照降序排序
        if (sortingType == "descending") {
          this.applyProductTableData = this.applyProductTableData.sort((a, b) => b[fieldName] - a[fieldName]);
        } else {
          //按照升序排序
          this.applyProductTableData = this.applyProductTableData.sort((a, b) => a[fieldName] - b[fieldName]);
        }
      } else {
        //字符串按照降序排序
        if (sortingType == "descending") {
          this.applyProductTableData = this.applyProductTableData.sort((a, b) => a[fieldName] == null ? -1 : a[fieldName].localeCompare(b[fieldName] == null ? -1 : b[fieldName]));

        } else {
          //按照升序排序
          this.applyProductTableData = this.applyProductTableData.sort((a, b) => b[fieldName] == null ? -1 : b[fieldName].localeCompare(a[fieldName] == null ? -1 : a[fieldName]));
        }
      }
      //再转换为时间格式
      if (fieldName == "effectiveBeginDate") {
        this.applyProductTableData.map(item => {
          item.effectiveBeginDate = this.$options.filters["dateFormatFilter"](item.effectiveBeginDate)
        });
      }


    },
    tableRowClassName({ row, rowIndex }) {
      if (row.colour === 'Y') {
        return 'success-row-q';
      } else {
        return '';
      }
    },
    formatisSpecial(row, column) {
      console.log('row', row);
      return row.isSpecialFreight == "Y" ? "是" : "否"
    },
  }
};
</script>
<style lang="scss">
.productQuotationApplicationAdd {
  .elx-table .success-row-q {
    background: #ffa796;
  }
}
</style>
